import { isEmpty } from 'lodash'
import { RawAdobeAnalytics } from '../types'

export const adobeAnalyticsFactory = (rawAnalytics: RawAdobeAnalytics) => {
    if (isEmpty(rawAnalytics) || isEmpty(rawAnalytics.adobe)) return null

    return {
        mediaId: rawAnalytics.adobe['mcs.sdk4.mediaid'],
        mediaName: rawAnalytics.adobe['a.media.name'],
    }
}
